// modules
import XLSX from 'xlsx'
import moment from 'moment'
// services
import db from '@/services/db'
// store
import store from '@/store'
// helpers
import eventBus from '@/helpers/event-bus'

const utils = {
  cursorToEnd: contentEditableElement => {
    let range
    let selection
    if (document.createRange) {
      // Firefox, Chrome, Opera, Safari, IE 9+
      range = document.createRange() // Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement) // Select the entire contents of the element with the range
      range.collapse(false) // collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection() // get the selection object (allows you to change selection)
      selection.removeAllRanges() // remove any selections already made
      selection.addRange(range) // make the range you have just created the visible selection
    } else if (document.selection) {
      // IE 8 and lower
      range = document.body.createTextRange() // Create a range (a range is a like the selection but invisible)
      range.moveToElementText(contentEditableElement) // Select the entire contents of the element with the range
      range.collapse(false) // collapse the range to the end point. false means collapse to end rather than the start
      range.select() // Select the range (make it the visible selection
    }
  },
  inputCursorToEnd: input => {
    let originalValue = input.val()
    input.val('')
    input.focus().val(originalValue)
  },
  count(obj) {
    var count = 0
    for (let i in obj) {
      // eslint-disable-line
      if (i === 'rmIndex') continue
      count++
    }
    return count
  },
  getColLabel(colIndex) {
    let label = ''
    let availableLabels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
    while (colIndex > 0) {
      let i = colIndex % availableLabels.length

      if (colIndex + 1 < availableLabels.length) {
        i--
      }

      label = availableLabels[i] + label
      colIndex = Math.floor(colIndex / availableLabels.length)
    }
    return label
  },
  getColIndex(colLabel) {
    let availableLabels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
    let colIndex = 0

    if (colLabel.length > 1) {
      let labelParts = colLabel.split('')
      labelParts = labelParts.map(part => {
        return availableLabels.indexOf(part) + 1
      })
      for (let i = 0; i < labelParts.length; i++) {
        if (i + 1 === labelParts.length) {
          colIndex += labelParts[i]
        } else {
          colIndex += Math.pow(availableLabels.length * labelParts[i], i + 1)
        }
      }
    } else {
      colIndex = availableLabels.indexOf(colLabel) + 1
    }
    return colIndex >= availableLabels.length ? colIndex - 1 : colIndex
  },
  readExcelFile(file, callback) {
    const reader = new FileReader()

    reader.onload = e => {
      const data = e.target.result
      const workbook = XLSX.read(data, {
        type: 'binary',
      })

      workbook.SheetNames.forEach(sheetName => {
        const sheetData = workbook.Sheets[sheetName]
        const result = {}

        for (let key in sheetData) {
          if (key[0] === '!') continue
          result[key] = sheetData[key].w
        }

        callback(result)
      })
    }

    reader.onerror = ex => {
      console.log(ex)
    }

    reader.readAsBinaryString(file)
  },
  readExcelFileToJSON(file, callback) {
    const reader = new FileReader()

    reader.onload = e => {
      const data = e.target.result
      const workbook = XLSX.read(data, {
        type: 'binary',
      })

      const result = []

      workbook.SheetNames.forEach(sheetName => {
        const sheetData = workbook.Sheets[sheetName]
        const list = { name: sheetName }
        const d = XLSX.utils.sheet_to_json(sheetData, { raw: true })

        list.data = d

        result.push(list)
      })

      callback(result)
    }

    reader.onerror = ex => {
      console.log(ex)
    }

    reader.readAsBinaryString(file)
  },
  readExcelFileToJSON2(file, callback) {
    const reader = new FileReader()

    reader.onload = e => {
      const data = e.target.result
      const workbook = XLSX.read(data, {
        type: 'binary',
      })

      const result = []

      workbook.SheetNames.forEach(sheetName => {
        const sheetData = workbook.Sheets[sheetName]
        const list = { name: sheetName }
        const d = XLSX.utils.sheet_to_json(sheetData, { raw: false })

        list.data = d

        result.push(list)
      })

      callback(result)
    }

    reader.onerror = ex => {
      console.log(ex)
    }

    reader.readAsBinaryString(file)
  },
  excelFromClipboard(e, callback) {
    e.preventDefault()
    let cb
    let clipText = ''
    if (window.clipboardData && window.clipboardData.getData) {
      cb = window.clipboardData
      clipText = cb.getData('Text')
    } else if (e.clipboardData && e.clipboardData.getData) {
      cb = e.clipboardData
      clipText = cb.getData('text/plain')
    } else {
      cb = e.originalEvent.clipboardData
      clipText = cb.getData('text/plain')
    }
    let clipRows = clipText.split('\n')
    for (let i = 0; i < clipRows.length; i++) {
      clipRows[i] = clipRows[i].split('\t')
    }
    let jsonObj = []
    for (let i = 0; i < clipRows.length - 1; i++) {
      let item = {}
      for (let j = 0; j < clipRows[i].length; j++) {
        if (clipRows[i][j] !== '\r') {
          if (clipRows[i][j].length !== 0) {
            item[j] = clipRows[i][j]
          }
        }
      }
      jsonObj.push(item)
    }

    let result = {}

    for (let i in jsonObj) {
      let row = jsonObj[i]
      for (let j in row) {
        let cell = utils.$getColLabel(+j + 1) + (+i + 1)
        let value = jsonObj[i][j]
        result[cell] = value
      }
    }

    callback(result)
  },
  buildACLRule(subject, actions) {
    let rule = {
      subject,
      actions: [],
    }
    let rules = []

    for (let action in actions) {
      if (actions[action]) rule.actions.push(action)
    }

    rules[subject] = rule

    return rules
  },
  isInViewport(elem) {
    var bounding = elem.getBoundingClientRect()
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    )
  },
  getData(vals, key) {
    var dataGridVals = {}
    var row2 = {}

    for (let cellKey in vals) {
      const cell = vals[cellKey]

      switch (cell.type) {
        case 'string':
          row2[cellKey] = cell.value
          break
        case 'date':
          row2[cellKey] = cell.value
          break
        case 'lookup':
          row2[cellKey] = window.$getDataGridVal(cell)
          const lookUpTable = $dataGrid(cell.lookUpTable)
          if (lookUpTable) row2['$' + cellKey] = lookUpTable[cell.value]
          break
        case 'multi_lookup':
          row2[cellKey] = window.$getDataGridVal(cell)
          break
        case 'user':
          row2[cellKey] = window.$getDataGridVal(cell)
          break
        case 'multiline_text':
          row2[cellKey] = cell.value
          break
        case 'checkbox':
          row2[cellKey] = cell.value
          break
        case 'profile_image':
          row2[cellKey] = cell.value
          break
      }
    }

    if (key) row2['rowKey'] = key

    dataGridVals = row2

    return dataGridVals
  },
  dgBuildNewRow(meta) {
    let newRow = {}

    for (let cellKey in meta) {
      const cell = meta[cellKey]
      newRow[cellKey] = { type: cell.type }
      if (cell.defaultValueCode) {
        newRow[cellKey] = eval(`(function () { ${cell.defaultValueCode} })()`)
      }
      if (cell.type === 'lookup' || cell.type === 'multi_lookup')
        newRow[cellKey].lookUpTable = cell.lookUpTable
    }

    return newRow
  },
  camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index == 0 ? word.toLowerCase() : word.toUpperCase()
      })
      .replace(/\s+/g, '')
  },
  sanitize(str1 = '') {
    const a = utils.camelize(str1)
    const b = a.replace(/-/g, '_')

    return escape(b)
  },
  async checkDomainAssignment(vm) {
    await new Promise(resolve => {
      db.root.ref('dashboardsAssignedToDomain').once('value', snapshot => {
        const mapping = snapshot.val()
        const domain = document.location.hostname
        let match = false

        if (!mapping) {
          const lastDash = localStorage.getItem('lastDash')
          if (lastDash) {
            vm.$router.push(`/dashboard/${lastDash}`)
          } else {
            vm.$router.push('/home')
          }

          resolve()
          return
        }

        for (let item in mapping) {
          if (mapping[item].domain === domain) match = mapping[item].dashboard
        }

        if (!match) {
          const lastDash = localStorage.getItem('lastDash')
          if (lastDash) {
            vm.$router.push(`/dashboard/${lastDash}`)
          } else {
            vm.$router.push('/home')
          }

          resolve()
          return
        }

        localStorage.setItem('lastDash', match)
        vm.$router.push(`/dashboard/${match}`)
        resolve()
      })
    })
  },
  evaluate(code, args = {}) {
    // Call is used to define where "this" within the evaluated code should reference.
    // eval does not accept the likes of eval.call(...) or eval.apply(...) and cannot
    // be an arrow function
    return function evaluateEval() {
      // Create an args definition list e.g. "arg1 = utils.arg1, arg2 = utils.arg2"
      const argsStr = Object.keys(args)
        .map(key => `${key} = utils.${key}`)
        .join(',')
      const argsDef = argsStr ? `let ${argsStr};` : ''

      return eval(`${argsDef}${code}`)
    }.call(args)
  },
  dgGetFieldOptions(propName, dgOptions) {
    console.log(propName, dgOptions)
  },
  getDGFBControl(formData, propName, native) {
    formData = JSON.parse(formData)

    if (!formData.sections) return null

    for (let section of formData.sections) {
      if (!section.rows) return null

      for (let row of section.rows) {
        if (!row.controls) return null

        const control = _.find(row.controls, {
          [native ? 'name' : 'propName']: propName,
        })

        if (control) return control
      }
    }

    return null
  },
  instByClass(instance, className) {
    try {
      let lookupInst = instance

      while (!$(lookupInst.$el).hasClass(className)) {
        lookupInst = lookupInst.$parent
      }

      return lookupInst
    } catch (err) {
      console.error(`Parent instance not found by class "${className}"`)
    }
  },
  evalExpression(expression) {
    try {
      const res = eval(expression)
      //console.log('evalExpression: ', expression, res)
      return res
    } catch (e) {}
  },
  formatDate(date) {
    return moment(date).format(store.state.dashboardSettings.regional.date)
  },
  releaseEvents() {
    const events = eventBus._events

    if (events) {
      for (let eventName in events) {
        const handlers = events[eventName] || []

        if (handlers.length) {
          for (let handler of handlers) {
            eventBus.$off(eventName, handler)
          }
        }
      }
    }
  },
  isDate(d) {
    return d instanceof Date && !isNaN(d)
  },
  isValidDate(d) {
    return d instanceof Date && !isNaN(d)
  },
}

export default utils
